















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import {
  ConvocationService,
  TypeOfProduct,
} from '@/manager/convocation/convocation.service';

export enum CardDecorationColor {
  Primary = 'card--decoration-primary',
  Secondary = 'card--decoration-secondary',
}

export enum CardNumber {
  Odd = 'card--odd',
  Even = 'card--even',
}

@Component
export default class Card extends Vue {
  @Prop({ default: CardDecorationColor.Primary })
  private cardDecorationColor!: CardDecorationColor;
  @Prop({ default: CardNumber.Even }) private cardNumber!: CardNumber;

  public props() {
    return [this.cardDecorationColor, this.cardNumber];
  }
}
